import Modal from './Modal';
import UserAvatar from './UserAvatar';
import { CameraIcon, LoaderIcon } from './Icons';
import useUserProfile from '../hooks/useUserProfile';

export default function UserProfileModal({ userProfile, onClose, onProfileUpdated, showToast }) {
  const { uploading, preview, fileRef, handleFileSelect, handleUpload, handleCancel } =
    useUserProfile({ userProfile, onProfileUpdated, onClose, showToast });

  return (
    <Modal
      title="My Profile"
      onClose={onClose}
      footer={
        preview ? (
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <button className="btn btn-ghost btn-sm" onClick={handleCancel} disabled={uploading}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm" onClick={handleUpload} disabled={uploading}>
              {uploading ? <><LoaderIcon size={14} /> Saving...</> : 'Save Photo'}
            </button>
          </div>
        ) : null
      }
    >
      <div className="profile-modal-content">
        <div className="profile-avatar-section">
          <div className="profile-avatar-wrapper">
            {preview ? (
              <div className="profile-avatar-large">
                <img src={preview} alt="Preview" className="profile-avatar-preview" />
              </div>
            ) : (
              <UserAvatar user={userProfile} size={80} showStatus={false} />
            )}
            <button
              className="profile-change-photo-btn"
              onClick={() => fileRef.current?.click()}
              disabled={uploading}
            >
              <CameraIcon size={14} /> Change Photo
            </button>
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              onChange={handleFileSelect}
              style={{ display: 'none' }}
            />
          </div>
        </div>
        <div className="profile-info-section">
          <div className="profile-info-row">
            <span className="profile-info-label">Name</span>
            <span className="profile-info-value">{userProfile.displayName}</span>
          </div>
          <div className="profile-info-row">
            <span className="profile-info-label">Email</span>
            <span className="profile-info-value">{userProfile.email}</span>
          </div>
          <div className="profile-info-row">
            <span className="profile-info-label">Role</span>
            <span className="profile-info-value" style={{ textTransform: 'capitalize' }}>{userProfile.role}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
}
